import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/axios';
import { getapiKey } from '../../api/axios';

const getAuthHeaders = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  if (!user?.token) {
    throw new Error("Authentication token is missing or invalid");
  }
  return {
    Authorization: `Bearer ${user.token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  };
};
const getAuthHeadersapiKey = () => {
  return {
    Authorization: `Bearer ${getapiKey()}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  };
};
export const fetchService = createAsyncThunk(
  "tickets/services",
  async ({ }, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/tickets/services`, { headers: getAuthHeaders() }
      );
      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        error: error.response?.data,
      });
    }
  }
);
export const fetchServiceissues = createAsyncThunk(
  "tickets/services/issues",
  async ({ service_id }, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/tickets/services/${service_id}/issues`, { headers: getAuthHeaders() }
      );
      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        error: error.response?.data,
      });
    }
  }
);
export const fetchticketList = createAsyncThunk(
  'tickets/list',
  async ({ params, perPage, currentPage }, { rejectWithValue }) => {
    try {
      let url = `/tickets/list?per_page=${perPage}&page=${currentPage}`;
      // API call to validate fare
      const response = await api.post(
        url,
        params,
        { headers: getAuthHeaders() }
      );
      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || 'Failed to validate fare',
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
export const CreateTickets = createAsyncThunk(
  "tickets/create",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/tickets/store`, formData, {
        headers: {
          ...getAuthHeaders(),
          "Content-Type": "multipart/form-data", // Important for file upload
        },
      }
      );
      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        error: error.response?.data,
      });
    }
  }
);
export const getTicketMessages = createAsyncThunk(
  'tickets/messages',
  async ({ ticketId }, { rejectWithValue }) => {
    try {
      let url = `/tickets/${ticketId}/messages`;
      // API call to validate fare
      const response = await api.get(
        url,
        ticketId,
        { headers: getAuthHeaders() }
      );
      console.log(response.data);

      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || 'Failed to validate fare',
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const sendTicketMessage = createAsyncThunk(
  'tickets/reply',
  async ({ ticketId, text, files }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('message', text);

      if (files && files.length > 0) {
        files.forEach(file => {
          formData.append('attachments[]', file);
        });
      }
      const response = await api.post(
        `/tickets/${ticketId}/reply`,
        formData,
        {
          headers: {
            ...getAuthHeaders(),
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue({
        message: error.message || 'Failed to send message',
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const SubmitEnquiry = createAsyncThunk(
  "enquiry/generatequery",
  async (form, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/enquiry/generatequery`, form, {
        headers: {
          ...getAuthHeadersapiKey(),
          "Content-Type": "multipart/form-data", // Important for file upload
        },
      }
      );
      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        error: error.response?.data,
      });
    }
  }
);

const ticketsSlice = createSlice({
  name: 'tickets',
  initialState: {
    loading: false,
    error: null,
    servicesData: [],
    servicesIssueData: [],
    CreateTicketData: [],
    EnquiryData: [],
    TicketListData: [],
    MessagesData: [],
    ServiceStatus: 'idle', // 'idle', 'initiated', 'success', 'failed'
    ServiceIssueStatus: 'idle', // 'idle', 'initiated', 'success', 'failed'
    CreateTicketStatus: 'idle', // 'idle', 'initiated', 'success', 'failed'
    Enquirytatus: 'idle', // 'idle', 'initiated', 'success', 'failed'
    fetcticketListtatus: 'idle', // 'idle', 'initiated', 'success', 'failed'
    MessageStatus: 'idle', // 'idle', 'initiated', 'success', 'failed'
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    resetTicket: (state) => {
      state.loading = false;
      state.error = null;
      state.servicesData = [];
      state.servicesIssueData = [];
      state.CreateTicketData = [];
      state.EnquiryData = [];
      state.TicketListData = [];
      state.MessagesData = [];
      state.ServiceStatus = 'idle';
      state.ServiceIssueStatus = 'idle';
      state.CreateTicketStatus = 'idle';
      state.Enquirytatus = 'idle';
      state.fetcticketListtatus = 'idle';
      state.MessageStatus = 'idle';
    },
  },
  extraReducers: (builder) => {
    builder
      // Initiate Easebuzz Payment
      .addCase(fetchService.pending, (state, action) => {
        state.ServiceStatus = "loading";
      })
      .addCase(fetchService.fulfilled, (state, action) => {
        state.servicesData = action.payload.data || [];
        state.ServiceStatus = "succeeded";
      })
      .addCase(fetchService.rejected, (state, action) => {
        state.ServiceStatus = "failed";
      })
      .addCase(fetchServiceissues.pending, (state, action) => {
        state.ServiceIssueStatus = "loading";
      })
      .addCase(fetchServiceissues.fulfilled, (state, action) => {
        state.servicesIssueData = action.payload.data || [];
        state.ServiceIssueStatus = "succeeded";
      })
      .addCase(fetchServiceissues.rejected, (state, action) => {
        state.ServiceIssueStatus = "failed";
      })
      .addCase(CreateTickets.pending, (state, action) => {
        state.CreateTicketStatus = "loading";
      })
      .addCase(CreateTickets.fulfilled, (state, action) => {
        state.CreateTicketData = action.payload.data || [];
        state.CreateTicketStatus = "succeeded";
      })
      .addCase(CreateTickets.rejected, (state, action) => {
        state.CreateTicketData = action.payload.data || [];
        state.CreateTicketStatus = "failed";
      })
      .addCase(SubmitEnquiry.pending, (state, action) => {
        state.Enquirytatus = "loading";
      })
      .addCase(SubmitEnquiry.fulfilled, (state, action) => {
        state.EnquiryData = action.payload.data || [];
        state.Enquirytatus = "succeeded";
      })
      .addCase(SubmitEnquiry.rejected, (state, action) => {
        state.EnquiryData = action.payload.data || [];
        state.Enquirytatus = "failed";
      })
      .addCase(fetchticketList.pending, (state, action) => {
        state.fetcticketListtatus = "loading";
      })
      .addCase(fetchticketList.fulfilled, (state, action) => {
        state.TicketListData = action.payload.data || [];
        state.fetcticketListtatus = "succeeded";
      })
      .addCase(fetchticketList.rejected, (state, action) => {
        state.CreateTicketData = action.payload.data || [];
        state.fetcticketListtatus = "failed";
      })
      .addCase(getTicketMessages.pending, (state, action) => {
        state.MessageStatus = "loading";
      })
      .addCase(getTicketMessages.fulfilled, (state, action) => {
        state.MessagesData = action.payload.data || [];
        state.MessageStatus = "succeeded";
      })
      .addCase(getTicketMessages.rejected, (state, action) => {
        state.CreateTicketData = action.payload.data || [];
        state.MessageStatus = "failed";
      });
  },
});

export const {
  clearError,
  resetTicket,
} = ticketsSlice.actions;

export const selectservicesData = (state) => state.tickets.servicesData;
export const selectServiceStatus = (state) => state.tickets.ServiceStatus;

export default ticketsSlice.reducer;